import { mapActions } from "vuex";
import AuthLayout from "@/components/auth/AuthLayout.vue";
import { SLIDES_PADRAO } from "@/components/auth/auth.js";

/** Chave do e-mail lembrado ("Lembrar de mim"). O token já fica sempre no localStorage. */
const LOGIN_EMAIL_KEY = 'login_email';

export default {
    components: { AuthLayout },

    data: () => ({
        loading: false,
        login: true,

        show1: false,
        lembrar: false,
        snackbar: false,
        text: '',
        timeout: 2000,
        form: {
            email: null,
            password: null,
        },
        erros: {
            email: '',
            password: '',
        },
        senhaRules: [
            (v) => !!v || "Senha é obrigátoria",
            (v) => (v && v.length >= 8) || "Mínimo de 8 caracteres",
        ],
        emailRules: [
            (v) => !!v || "E-mail obrigatório",
            (v) => /.+@.+\..+/.test(v) || "E-mail informado não é válido",
        ],

        // Frases do painel amarelo (carrossel no AuthLayout)
        slides: SLIDES_PADRAO,
    }),

    computed: {
        /** Sem erro aparente nos campos (o botão só desabilita depois de um erro mostrado). */
        valid() {
            return !this.erros.email && !this.erros.password;
        },
    },

    created() {
        const emailLembrado = lerEmailLembrado();
        if (emailLembrado) {
            this.form.email = emailLembrado;
            this.lembrar = true;
        }

        if (this.$route.query.validacao == 1) {
            this.$swal({
                toast: false,
                position: "center",
                showConfirmButton: true,
                icon: 'success',
                confirmButtonColor: "#2778c4",

                title: 'Cadastro validado com sucesso',
            });
        }
        if (this.$route.query.validacao == 2) {
            this.$swal({
                toast: false,
                position: "center",
                showConfirmButton: true,
                icon: 'error',
                confirmButtonColor: "#2778c4",
                title: 'Link de verificação expirado, estamos enviando um novo para o seu email.',
            });
        }
        if (this.$route.query.validacao == 3) {
            this.$swal({
                toast: false,
                position: "center",
                showConfirmButton: true,
                icon: 'info',
                confirmButtonColor: "#2778c4",
                title: 'Cadastro já verificado anteriormente.',
            });
        }
    },

    methods: {
        ...mapActions("auth", ["ActionDoLogin"]),

        /** Aplica as regras do campo e guarda a primeira mensagem de erro (ou ''). */
        validarCampo(campo) {
            const regras = campo === 'email' ? this.emailRules : this.senhaRules;
            const falha = regras.map((regra) => regra(this.form[campo])).find((r) => r !== true);
            this.erros[campo] = falha || '';
            return !falha;
        },

        validar() {
            const emailOk = this.validarCampo('email');
            const senhaOk = this.validarCampo('password');
            return emailOk && senhaOk;
        },

        async submit() {
            // Antes ia para a API mesmo com e-mail/senha vazios
            if (!this.validar()) return;

            this.loading = true
            this.login = false

            try {
                await this.ActionDoLogin(this.form);
                this.salvarEmailLembrado();

                if (this.$store.state.auth.user.empresas.length > 0) {
                    this.$router.push({ name: "selecionarEmpresa" });
                } else {

                    this.$router.push({ name: "Bem Vindo" });
                }
            } catch (error) {
                this.loading = false
                this.login = true
                this.text = error.data ? error.data.message : "Não foi possivel fazer login";
                this.snackbar = true

            }
        },

        /** "Lembrar de mim" só lembra o e-mail; não altera a sessão. */
        salvarEmailLembrado() {
            try {
                if (this.lembrar) {
                    localStorage.setItem(LOGIN_EMAIL_KEY, this.form.email);
                } else {
                    localStorage.removeItem(LOGIN_EMAIL_KEY);
                }
            } catch (e) {
                // localStorage indisponível (modo privado restrito): segue sem lembrar
            }
        },

        cadastrar() {

            this.$router.push({ name: "cadastrar" });
        },
        recuperarAcesso() {

            this.$router.push({ path: "recuperaracesso" });
        },
    },
};

function lerEmailLembrado() {
    try {
        return localStorage.getItem(LOGIN_EMAIL_KEY);
    } catch (e) {
        return null;
    }
}
